import { defineStore } from 'pinia';
import LeadSourcesAPI from 'dashboard/api/leadSources';

export const useLeadSourcesStore = defineStore('leadSources', {
  state: () => ({
    list: [],
    current: null,
    loading: false,
    saving: false,
  }),
  actions: {
    async fetchAll(params = {}) {
      this.loading = true;
      try {
        const { data } = await LeadSourcesAPI.list(params);
        this.list = data;
      } finally {
        this.loading = false;
      }
    },
    async fetchOne(id) {
      const { data } = await LeadSourcesAPI.show(id);
      this.current = data;
      return data;
    },
    async create(payload) {
      this.saving = true;
      try {
        const { data } = await LeadSourcesAPI.create({ lead_source: payload });
        this.list = [data, ...this.list];
        return data;
      } finally {
        this.saving = false;
      }
    },
    async update(id, payload) {
      this.saving = true;
      try {
        const { data } = await LeadSourcesAPI.update(id, {
          lead_source: payload,
        });
        this.list = this.list.map(s => (s.id === id ? data : s));
        if (this.current?.id === id) this.current = data;
        return data;
      } finally {
        this.saving = false;
      }
    },
    async destroy(id) {
      await LeadSourcesAPI.delete(id);
      this.list = this.list.filter(s => s.id !== id);
      if (this.current?.id === id) this.current = null;
    },
    async rotateToken(id) {
      const { data } = await LeadSourcesAPI.rotateToken(id);
      this.list = this.list.map(s => (s.id === id ? data : s));
      if (this.current?.id === id) this.current = data;
      return data;
    },
    async runNow(id) {
      const { data } = await LeadSourcesAPI.runNow(id);
      return data;
    },
  },
});
